@if (apPegaChannel === 'retail-standalone') {
    <div data-bb="pega-retail-standalone">
        <ap-header ap-display-block ap-margin-bottom-2 layout="small" variant="standalone" logoLink="/"></ap-header>
        <div class="canvas-small">
            <ng-container [ngTemplateOutlet]="pegaRetail"></ng-container>
        </div>
    </div>
} @else {
    <div data-bb="pega-retail-embed">
        <ng-container [ngTemplateOutlet]="pegaRetail"></ng-container>
    </div>
}

<ng-template #pegaRetail>
    @if (isLoading) {
        <generic-skeleton></generic-skeleton>
    } @else {
        <pega-retail
            (assignmentNameChanged)="onAssignmentNameChanged($event)"
            (caseChange)="onCaseChange($event)"
            (caseTypeChange)="onCaseTypeChange($event)"
            (loadAction)="onLoadAction($event)"
            (nextAction)="onNextAction($event)"
            (onAssignmentComplete)="onAssignmentComplete($event)"
            [actionID]="pegaResumeActionID"
            [assignmentID]="pegaResumeAssignmentID"
            [caseID]="pegaResumeCaseID"
            [caseTypeID]="caseTypeID"
            [content]="pegaContent"
            [initWithSubmit]="pegaResumeInitWithSubmit"
            [pegaExtraHeaders]="pegaExtraHeaders"
            [useState]="apPegaUseState"
        >
        </pega-retail>
    }
</ng-template>
